module.exports = __webpack_public_path__ + "static/banner_vote_mobile-9ec93ee71f96e7e88b294a2cb842b6db.png";